module.exports = __webpack_public_path__ + "img/FR16607.b8b252a1.png";